import MessageApi from '../../../../api/inbox/message';

export default {
  async getForwardQuoteMessages(_, { conversationId, messageId, limit }) {
    try {
      const response = await MessageApi.getForwardQuoteMessages({
        conversationId,
        messageId,
        limit,
      });
      return response.data.payload;
    } catch (error) {
      return [];
    }
  },
};
